<template>
  <div id="report" :class="[ 'style-' + reportStyle ]">

    <preloader v-if="this.$store.state.preloaderOn"/>

    <NavBar ref="navbar" v-if="isMobile"></NavBar>

    <side-nav v-if="!isMobile"></side-nav>

    <desk-controls v-if="!isMobile"></desk-controls>
    
    <router-view :win-h-forced="winHForced"/>

    <landscape-message ref="lsm" :override="tabletOverride"/>

  </div>
</template>

<script>
  import { colors, reportTxtStyles } from '@/lib/consts'
  import { TweenMax } from 'gsap'
  import { randInt } from '@/lib/funcs'
  import Preloader from '@/components/Preloader'
  import LandscapeMessage from '@/components/LandscapeMessage'
  import StateMixin from '@/components/report/mixins/StateMixin'
  import DeskControls from '@/components/report/DeskControls'
  import SideNav from '@/components/report/sideNav'
  import NavBar from './NavBar'

  export default {
    name: 'Report',
    mixins: [ StateMixin ],
    data () {
      return {
        winHForced: false,
        forceFactor: 1.15
      }
    },
    computed: {
      reportStyle () { return this.reportTxtStyle === reportTxtStyles.default ? 'default' : 'extended' },
      tabletOverride () { return this.formFactor === 'Tablet' }
    },
    methods: {
      onOrientationChange ( isPortrait ) {
        this.$nextTick( () => {
          if ( this.$refs.navbar ) {
            !isPortrait
              ? TweenMax.to( this.$refs.navbar.$el.firstChild, 0.5, { y: -this.navHeight } )
              : TweenMax.to( this.$refs.navbar.$el.firstChild, 0.5, { y: 0 } )
          }
        } )
      }
    },
    mounted () {
      this.$store.dispatch( 'setPreloader', true )
      this.$store.dispatch( 'setViewed' )

      if ( !this.$store.state.demoCapable ) {
        this.$store.dispatch( 'setColors', randInt( 0, colors.length ) )
      }
      if ( this.isMobile && this.isSmall && !this.isSafari ) {
        this.winHForced = window.innerHeight * this.forceFactor
      } else if ( this.isMobile && !this.isSmall ) {
        this.winHForced = window.innerHeight
      }

      if ( this.isSmall ) this.$refs.lsm.$on( 'orientationChange', this.onOrientationChange )

      window.addEventListener( 'deviceorientation', () => setTimeout( () => window.Waypoint.refreshAll(), 150 ) )
    },
    beforeRouteEnter ( to, from, next ) {
      next( vm => {
        vm.forceFactor = 1
      } )
    },
    beforeRouteUpdate ( to, from, next ) {
      this.forceFactor = 1
      if ( this.isMobile && this.isSmall && !this.isSafari ) {
        this.winHForced = window.innerHeight * this.forceFactor
      }
      next()
    },
    beforeRouteLeave ( to, from, next ) {
      document.body.classList.remove( 'hide-gnav' )
      TweenMax.to( '#report', 0.4, { opacity: 0, onComplete: next } )
    },
    components: {
      LandscapeMessage,
      Preloader,
      NavBar,
      DeskControls,
      SideNav
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/Report.vue